<template>
  <div class="flex min-h-screen bg-primaryBg font-inter">
    <aside class="hidden md:block w-[294px] flex-shrink-0 bg-primaryBg text-primaryDark">
      <Sidebar />
    </aside>
    <div class="flex-grow">
      <main class="w-full">
        <LearningPlanDetailsComponent :templateId="templateId" />
      </main>
    </div>
  </div>
</template>

<script>
import LearningPlanDetailsComponent from '@/components/learning-plans/LearningPlanDetailsComponent.vue';
import Sidebar from '@/components/SidebarComponent.vue';

export default {
  name: 'LearningPlanDetailsView',
  components: {
      Sidebar,
      LearningPlanDetailsComponent,
  },
  computed: {
    templateId() {
      return this.$route.params.id;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
}
</script>

<style scoped>
</style>
